import { assert } from "@ndn/util";
import { TypedEventTarget } from "typescript-event-target";
/** Congestion avoidance algorithm. */
export class CongestionAvoidance extends TypedEventTarget {
    cwnd_;
    /**
     * Constructor.
     * @param initialCwnd - Initial congestion window.
     */
    constructor(initialCwnd) {
        super();
        this.cwnd_ = initialCwnd;
    }
    /** Congestion window. */
    get cwnd() { return this.cwnd_; }
    updateCwnd(v) {
        assert(Number.isFinite(v));
        assert(v >= 0);
        this.cwnd_ = v;
        this.dispatchTypedEvent("cwndupdate", new Event("cwndupdate"));
    }
}
